export default `#ifdef GL_ES
  precision highp float;
#endif

varying float vSlope;
uniform vec3 u_colors[2];
uniform float base_opacity;

void main(){
  gl_FragColor = vec4( u_colors[0].rgb + (u_colors[1].rgb - u_colors[0].rgb) * pow(vSlope, 5.0), base_opacity);
}`